export const SEQUENCE = {
  HEADER_Y: 40,
  HEADER_HEIGHT: 44,
  HEADER_WIDTH: 140,
  MIN_LABEL_WIDTH: 96,
  LABEL_SAFE_MARGIN: 4,
  STICKY_TOP: 12,
  STICKY_TOP_WITH_HEADER: 84,
  STICKY_BOTTOM_INSET: 12,
  /** Minimum gap between an alt fragment header and its divider. */
  ALT_DIVIDER_TOP_GAP: 40,
  /** Minimum gap between an alt fragment divider and its closing edge. */
  ALT_DIVIDER_BOTTOM_GAP: 28,
  /** Padding between an alt branch's last/first message and the divider. */
  ALT_DIVIDER_MESSAGE_PADDING: 12,
  /** Control-fragment header (LOOP/ALT/OPT/PAR label row). */
  FRAGMENT_LABEL_HEIGHT: 24,
  /** Gap between a fragment frame and a neighboring message line/label. */
  FRAGMENT_OUTSIDE_GAP: 12,
  /** Padding from first in-fragment message footprint to the frame top (header + gap). */
  FRAGMENT_PAD_TOP: 36,
  FRAGMENT_PAD_TOP_ALT: 56,
  /** Padding from last in-fragment message footprint to the frame bottom. */
  FRAGMENT_PAD_BOTTOM: 24,
  FRAGMENT_PAD_BOTTOM_ALT: 28,
  FRAGMENT_MIN_HEIGHT: 60,
  /** Nested child inset relative to its parent frame. */
  FRAGMENT_NEST_PAD: 10,
  /** Keep the current parent unless the child has clearly left by this many pixels. */
  FRAGMENT_NEST_HYSTERESIS: 16,
  /** Extra space between consecutive message lines (in addition to footprints). */
  MESSAGE_VERTICAL_BUFFER: 6,
} as const;

export const FRAGMENT_COLORS: Record<string, string> = {
  loop: '#3b82f6',
  alt: '#f59e0b',
  opt: '#10b981',
  par: '#8b5cf6',
};

export const SEQUENCE_PARTICIPANT_COLORS = [
  '#6366f1', '#10b981', '#f59e0b', '#ec4899', '#06b6d4',
  '#ef4444', '#8b5cf6', '#f97316', '#84cc16', '#14b8a6',
  '#e11d48', '#0ea5e9', '#22c55e', '#a855f7', '#3b82f6',
  '#9333ea', '#65a30d', '#0891b2', '#d97706', '#db2777',
] as const;
